export default "__VITE_ASSET__CTR9z1aF__"